import TextLabel from './TextLabel';

export default TextLabel;
